import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, LanguageService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { ApplicationType } from '../../utils/enums/applicationType.enum';
import { CustomerRemarkFactoryService } from './customerremark-plugin-factory.service';

@Injectable()
export class CustomerRemarkPluginService extends InspectionPluginService {
  public typeKeys: any = [
    { value: 2, label: 'remark-reporter.type.machine-operator' },
    { value: 1, label: 'remark-reporter.type.maintenance-manager' },
    { value: 0, label: 'remark-reporter.type.production-manager' }
  ];

  private managerKeys: any = [{ value: 3, label: 'remark-reporter.type.upper-management' }];

  public types: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private language: LanguageService,
    private remarkFactory: CustomerRemarkFactoryService
  ) {
    super(apiService, dataService, null, remarkFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateComment(inspectionId: string, pointId: string, pluginId: string, remarks: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, remarks).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getTypes() {
    return this.types;
  }

  public applyTranslations() {
    this.types = [];
    let keys = this.typeKeys;
    if (this.applicationType === ApplicationType.Optimization) {
      keys = [...this.managerKeys, ...this.typeKeys];
    }
    this.copyTranslationValues(keys, this.types, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, remarks: any): Observable<any> {
    return this.remarkFactory.updateComment(inspectionId, pointId, pluginId, remarks, 'Remarks').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
